import type { RequestParams } from '@/shared/api';

export const ORDER_KEYS = {
  all: ['order'] as const,
  list: (params?: RequestParams) => [...ORDER_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...ORDER_KEYS.all, 'detail', id] as const,
};
